/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Payment_UpdatedInputs */

const en_plan_payment_updated = /** @type {(inputs: Plan_Payment_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment method updated`)
};

const es_plan_payment_updated = /** @type {(inputs: Plan_Payment_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Método de pago actualizado`)
};

/**
* | output |
* | --- |
* | "Payment method updated" |
*
* @param {Plan_Payment_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_payment_updated = /** @type {((inputs?: Plan_Payment_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Payment_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_payment_updated(inputs)
	return en_plan_payment_updated(inputs)
});